export default __webpack_public_path__ + "static/media/21_9kontakt.00cef8c1.jpg";